module.exports = __webpack_public_path__ + "img/trash_empty_thin.b165f4c4.svg";